<template>
  <div class="TitleContentBlock">
    <div class="grid">
      <div class="col-9-12 sm-col-1-1">
        <UIHeadingType
          class="mb-xlg"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
        <UIContentblockButton
          v-if="content.linkObject"
          class="btn btn-tertiary"
          :name="content.linkObject?.name"
          :link="content.linkObject?.link"
          :target="content.linkObject?.target"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TitleColumnContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  defineProps<{
    content: TitleColumnContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()
</script>
